import imgMainBottom from '@/assets/images/login/img_main_bottom.png'
import imgMainTop1 from '@/assets/images/login/img_main_top_1.png'
import imgMainTop2 from '@/assets/images/login/img_main_top_2.png'

interface MainImagesProps {
  isRegister: boolean
}

export const MainImages = ({ isRegister }: MainImagesProps) => {
  return (
    <div className="absolute left-[15%] top-[60%] -translate-y-1/2 w-[400px]">
      <div className="animate-glow-pulse-blue">
        <img
          src={imgMainBottom}
          alt=""
          key={`bottom-${isRegister ? 'register' : 'login'}`}
          className="w-full relative z-10 transition-all  animate-switch-glow "
        />
      </div>
      <div className="absolute -top-[30%] left-1/2 -translate-x-1/2 -translate-y-[35%] z-20 w-[90%] animate-float-main">
        <img
          key={isRegister ? 'register' : 'login'}
          src={isRegister ? imgMainTop2 : imgMainTop1}
          alt=""
          className="w-full transition-all duration-1000 animate-in fade-in"
        />
      </div>
    </div>
  )
}
